"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserEventbriteTicketDto = exports.UserTicketDto = exports.UserTicketEventDto = exports.EventTicketStatusDto = exports.EventbriteTicketDto = exports.TicketDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const RefundRequest_dto_1 = require("./RefundRequest.dto");
class TicketDto {}
exports.TicketDto = TicketDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], TicketDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], TicketDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.TicketStatus,
  description: 'Payment state, synced with Square.'
}), __metadata("design:type", String)], TicketDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Number of admissions on this ticket.'
}), __metadata("design:type", Number)], TicketDto.prototype, "quantity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Unit price in cents (USD), captured at purchase time.'
}), __metadata("design:type", Number)], TicketDto.prototype, "priceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount charged in cents (USD): priceCents × quantity.'
}), __metadata("design:type", Number)], TicketDto.prototype, "totalCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount refunded so far in cents (USD).'
}), __metadata("design:type", Number)], TicketDto.prototype, "refundedCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'e.g. VISA, MASTERCARD. Null until Square reports the card.'
}), __metadata("design:type", Object)], TicketDto.prototype, "cardBrand", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], TicketDto.prototype, "cardLast4", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square-hosted receipt page.'
}), __metadata("design:type", Object)], TicketDto.prototype, "receiptUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square error code of the last failed attempt, e.g. GENERIC_DECLINE.'
}), __metadata("design:type", Object)], TicketDto.prototype, "failureCode", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], TicketDto.prototype, "purchasedAt", void 0);
/**
 * A valid Eventbrite order the user placed for an Ivy event. Only returned for events Ivy marks as
 * ticketed (`isTicketed`) — Ivy is the source of truth for whether an event has tickets.
 */
class EventbriteTicketDto {}
exports.EventbriteTicketDto = EventbriteTicketDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteTicketDto.prototype, "eventbriteOrderId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteTicketDto.prototype, "eventbriteEventId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteTicketDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Attendees on the order that are neither cancelled nor refunded.'
}), __metadata("design:type", Number)], EventbriteTicketDto.prototype, "quantity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Order gross in minor units (cents), as Eventbrite reports it.'
}), __metadata("design:type", Object)], EventbriteTicketDto.prototype, "totalCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], EventbriteTicketDto.prototype, "currency", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventbriteTicketDto.prototype, "purchasedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Where the user finds the ticket itself (QR code) on Eventbrite.'
}), __metadata("design:type", String)], EventbriteTicketDto.prototype, "ticketsUrl", void 0);
class EventTicketStatusDto {}
exports.EventTicketStatusDto = EventTicketStatusDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the current user holds an active ticket for this event (Ivy or Eventbrite).'
}), __metadata("design:type", Boolean)], EventTicketStatusDto.prototype, "hasTicket", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: TicketDto,
  nullable: true
}), __metadata("design:type", Object)], EventTicketStatusDto.prototype, "ticket", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: EventbriteTicketDto,
  nullable: true,
  description: 'Valid Eventbrite order for this event. Always null while the event is not ticketed on Ivy.'
}), __metadata("design:type", Object)], EventTicketStatusDto.prototype, "eventbriteTicket", void 0);
class UserTicketEventDto {}
exports.UserTicketEventDto = UserTicketEventDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserTicketEventDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserTicketEventDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], UserTicketEventDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], UserTicketEventDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], UserTicketEventDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Event address, falling back to the venue address. Null when hidden.'
}), __metadata("design:type", Object)], UserTicketEventDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserTicketEventDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], UserTicketEventDto.prototype, "venueLogoUrl", void 0);
class UserTicketDto extends TicketDto {}
exports.UserTicketDto = UserTicketDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: UserTicketEventDto
}), __metadata("design:type", UserTicketEventDto)], UserTicketDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user can ask for a refund right now (paid, something left to refund, no open request).'
}), __metadata("design:type", Boolean)], UserTicketDto.prototype, "canRequestRefund", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: RefundRequest_dto_1.RefundRequestSummaryDto,
  nullable: true,
  description: 'Latest refund request for this ticket.'
}), __metadata("design:type", Object)], UserTicketDto.prototype, "refundRequest", void 0);
class UserEventbriteTicketDto extends EventbriteTicketDto {}
exports.UserEventbriteTicketDto = UserEventbriteTicketDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: UserTicketEventDto
}), __metadata("design:type", UserTicketEventDto)], UserEventbriteTicketDto.prototype, "event", void 0);
//# sourceMappingURL=Ticket.dto.js.map